import { useState } from 'react';
import { signIn } from '../auth/msal';

/**
 * There is no password field and no email box. Identity comes from Entra ID —
 * the prototype's "type your email to continue" screen let anyone be anyone.
 */
export function SignIn() {
  const [busy, setBusy] = useState(false);

  return (
    <div className="centred">
      <div className="panel">
        <div style={{ fontSize: 22, fontWeight: 600, marginBottom: 4 }}>
          HOME<span style={{ color: 'var(--orange)' }}>PRO</span>
        </div>
        <h1>Complaints Manager</h1>
        <p>Sign in with your HomePro work account to continue.</p>
        <button
          type="button"
          className="btn primary"
          style={{ width: '100%', justifyContent: 'center' }}
          disabled={busy}
          onClick={() => {
            setBusy(true);
            void signIn().catch(() => setBusy(false));
          }}
        >
          {busy ? 'Redirecting…' : 'Sign in with Microsoft'}
        </button>
      </div>
    </div>
  );
}
